import { IonAlert } from '@ionic/react';
import { useTranslation } from 'react-i18next';

export interface DeleteConfirmationProps {
  header?: string;
  message?: string;
  confirmButtonText?: string;
  count?: number;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  deleteMe: () => void;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  header,
  message,
  confirmButtonText,
  count,
  isOpen,
  setIsOpen,
  deleteMe,
}) => {
  const { t } = useTranslation();

  if (!header) {
    header = 'delete';
  }
  if (!message) {
    message = 'delete';
  }
  if (!confirmButtonText) {
    confirmButtonText = 'delete';
  }

  return (
    <IonAlert
      cssClass="delete-confirmation"
      header={t(header, { count })!}
      message={t(message, { count })!}
      isOpen={isOpen}
      buttons={[
        {
          text: t('cancel'),
          role: 'cancel',
        },
        {
          text: t(confirmButtonText, { count }),
          role: 'destructive',
          handler: deleteMe,
        },
      ]}
      onWillDismiss={() => setIsOpen(false)}
    />
  );
};

export default DeleteConfirmation;
